import flatten from 'lodash/flatten';
import { getColumnFilteredValue, getColumnSortOrder } from '../../components/table/columnFormatHelpers';
import { ColumnsType } from 'antd/lib/table';
import { compareWithLocale } from '../compareWithLocale';
import { IEvent } from '../event/interface';
import { Typography } from 'antd';

export const getUtilityFilterValue = (state: any) => {
    let { filteredValue } = getColumnFilteredValue('site_utility', state?.filter || {});
    if (Array.isArray(filteredValue)) {
        filteredValue = flatten(filteredValue).map(utilityName => utilityName.toString());
    }
    return filteredValue;
};

export function buildEventUtilityTableFilter(state: any, utilities: string[]) {
    const column: ColumnsType<IEvent>[number] = {
        title: 'Utility',
        dataIndex: 'site_utility',
        sorter: (a, b) => compareWithLocale(a.site?.site_utility, b.site?.site_utility),
        ...getColumnSortOrder('site_utility', state.sorter),
        filters: utilities.map(utility => ({ text: utility, value: utility })),
        filteredValue: getUtilityFilterValue(state),
        filterSearch: (input, record) => !!record?.text?.toString()?.toLowerCase().includes(input.toLowerCase()),
        render: (text, record) => <Typography.Text>{record?.site?.site_utility}</Typography.Text>,
    };

    return column;
}
